import { css } from '@emotion/css'
import { spacing, borderRadius } from '../../styles'
import { getSkeletonColors } from '../../themes'

const styles = {
  card: css({
    boxSizing: 'border-box',
    display: 'flex',
    padding: spacing.default,
    borderRadius: borderRadius.default,
  }),
}

export default styles

export const boxTheme = theme =>
  css({
    backgroundColor: getSkeletonColors(theme),
  })
